import { useMemo } from 'react';
import useSWR from 'swr';
import { SERVICES } from '@shared/constants/apiConfig';
import { NavTabs } from '@shared/tabs/NavTabs';
import { filteredStipType, getOptions } from '@shared/commonFunctions';
import { useStipTypes } from '@shared/hooks/useStipTypes';
import { ILenderListItem } from '../../shared/LenderControlsHeader';
import { StateTab } from './StateTab';
import { LenderTab } from './LenderTab';

export const TItleScanTabs = () => {
  const { stipTypes } = useStipTypes();
  const { data: lenderList } = useSWR<ILenderListItem[]>(`/${SERVICES.LENDER}/lenders`);

  const stipTypeOptions = useMemo(() => getOptions(filteredStipType(stipTypes)), [stipTypes]);
  const lenderOptions = useMemo(() => getOptions(lenderList), [lenderList]);

  const tabs = useMemo(
    () => [
      {
        name: 'State ',
        component: <StateTab stipTypeOptions={stipTypeOptions} />,
      },
      {
        name: 'Lender ',
        component: (
          <LenderTab
            stipTypeOptions={stipTypeOptions}
            lenderList={lenderOptions}
          />
        ),
      },
    ],
    [stipTypeOptions, lenderOptions]
  );

  return (
    <NavTabs
      data={tabs}
      loading={false}
    />
  );
};
